import PropTypes from 'prop-types';
import React from 'react';

import connect from 'components/lib/connect';

export function RuleLink({ canViewRules, className, ruleId, shouldCapitalize }) {
  let linkText = shouldCapitalize ? 'Rule' : 'rule';
  if (!canViewRules || !ruleId) {
    return linkText;
  }

  let linkClassName = className || 'conversationItem-metadata-link';
  const route = `/admin/rules/${ruleId}`;
  let handleClick = evt => {
    evt.preventDefault();
    window.location.assign(route);
  };

  return (
    <a data-aid="adminRulesLink" href={route} className={linkClassName} onClick={handleClick}>
      {linkText}
    </a>
  );
}

RuleLink.propTypes = {
  canViewRules: PropTypes.bool,
  className: PropTypes.string,
  ruleId: PropTypes.string,
  shouldCapitalize: PropTypes.bool,
};

function mapStateToProps({ isFeatureEnabled }, { className, ruleId }) {
  return {
    canViewRules: isFeatureEnabled('rulesManagement'),
    className,
    ruleId,
  };
}

const RuleLinkContainer = connect(mapStateToProps)(RuleLink);

RuleLinkContainer.propTypes = {
  ruleId: PropTypes.string.isRequired,
  shouldCapitalize: PropTypes.bool,
};

export default RuleLinkContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/metadata/rule_link.jsx